<template>
    <form class="checkout-panel-column">
        <label class="label-field">
            <span class="field-name">{{ trans('general.email') }}</span>
            <input class="checkelement" v-model="login_data.email" required type="email" :placeholder="trans('general.your_email')">
            <input-notification/>
        </label>
        <div class="label-field-column">
            <label class="label-field">
                <span class="field-name">{{ trans('passwords.Password') }}</span>
                <input class="checkelement" v-model="login_data.password" required type="password" ref="password" :placeholder="trans('general.your_password')">
                <input-notification/>
                <button @click="showPassword" type="button" class="btn-eye">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#eye" />
                    </svg>
                </button>
            </label>
            <a :href="globalVariables.locale + '/forgot-password'" class="pass-link">
                {{ trans('passwords.forgot_password') }}
            </a>
        </div>
        <span v-if="notification.show" class="form-response label-field error warning">
            <span class="label-messages">
                <span class="field-message error-message">
                    {{ notification.text }}
                </span>
            </span>
        </span>
        <div class="btn-block">
            <button type="submit" @click="login" :class="{disabled: loading}" class="btn">
                {{ trans('general.resume') }}
            </button>
        </div>
    </form>
</template>

<script>
import axios from "axios";
import inputNotification from "./../inc/InputNotification";
import helper from "./../mixins/helper";

export default {
    mixins: [
        helper
    ],
    components: {
        "input-notification": inputNotification
    },
    props: {
    },
    data() {
        return {
            login_data: {
                email: null, // "andreisizyi@mavericks.agency",
                password: null, // "F7747vGMZ6xgdGx"
            },
            notification: {
                'show': false,
                'text': this.trans('auth.error_when_login')
            },
            loading: false
        }
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        showPassword() {
            let pass = this.$refs.password;
            if (pass.getAttribute('type') == 'password') {
                pass.setAttribute('type', 'text');
            } else {
                pass.setAttribute('type', 'password');
            }
        },
        login(e) {
            e.preventDefault();
            this.loading = true;
            axios({
                method: "post",
                url: window.globalVariables.locale + "/axio-login",
                data: this.login_data,
                config: {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            })
            .then(response => {
                this.$emit("set", response.data);
                this.loading = false;
            })
            .catch(error => {
                console.log(error.response);
                if (error.response.status = 422) {
                    this.notification = {
                        'show': true,
                        'text': this.trans('auth.wrong_combination_log_pass')
                    };
                }
                this.loading = false;
            });
        }
    }
}
</script>